var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfluentiaLogoNoLetters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 459,
    height: 390,
    viewBox: "0 0 459 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M412.884 116.718C377.277 90.0984 317.999 78.2823 224.715 96.4711C141.032 112.735 67.1515 147.917 49.6815 207.529C20.9427 195.182 0.405518 178.586 0.405518 148.316C0.405518 71.6441 83.4879 28.2301 179.306 9.57663C349.538 -23.6145 406.549 43.2325 412.884 116.718Z",
    fill: "#00EAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M378.06 242.842C326.784 308.295 261.105 324.227 194.559 267.669C156.485 235.142 93.4731 226.313 49.6648 207.527C67.1348 147.915 141.082 112.733 224.698 96.4689C317.982 78.2802 377.327 90.0962 412.867 116.716C417.001 164.644 399.664 215.36 378.06 242.908V242.842Z",
    fill: "#009FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M423.486 329.75C372.143 395.203 306.464 411.135 239.918 354.511C176.84 300.808 45.748 311.761 45.748 235.089C45.748 225.331 47.0816 216.17 49.6154 207.474C93.4904 226.26 156.436 235.155 194.51 267.616C261.055 324.241 326.735 308.309 378.011 242.789C399.615 215.241 417.018 164.525 412.818 116.597C484.498 169.968 460.026 283.017 423.42 329.684L423.486 329.75Z",
    fill: "#7641FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluentiaLogoNoLetters);
export default __webpack_public_path__ + "static/media/influentia-logo-no-letters.e440f01aa10dad741b5ac4efb6fcf43c.svg";
export { ForwardRef as ReactComponent };